import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/aiLibVideo/initialState'
import reducers from 'store/features/aiLibVideo/reducers'

export const aiLibVideoSlice = createSlice({
  name: 'aiLib',
  initialState: getInitialState(),
  reducers
})

export default aiLibVideoSlice
